import Block from '@/components/Cart/modal/Block/Block';
import Button from '@/components/Common/Button/Button';
import COLORS from '@/constants/colors';
import TableLayout from '@/layouts/TableLayout/TableLayout';
import { BUTTON_VARIANT } from '@/utils/enums';
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { forwardRef } from 'react';
import { CloseModalHandler } from '../CartModal';
import { DRAFT_ORDER_CONTAINER_TO_PRINT } from '../ModalBody';
import { TotalTicket } from '../TotalTicket';
import BuyerSearch from './BuyerSearch/BuyerSearch';
import { useCreateEditCartViewController } from './CreateEditCartBodyViewController';
import { ProductLine } from './ProductLine';
import ProductSearch from './ProductSearch/ProductSearch';
import { SellerTicket } from './SellerTicket';

export const CreateEditCartBody = forwardRef<CloseModalHandler, object>(
  function CreateEditCartBodyInner(_props, ref) {
    const { uiState, actions } = useCreateEditCartViewController(ref);

    return (
      <Stack id={DRAFT_ORDER_CONTAINER_TO_PRINT}>
        <Block>
          <Stack>
            <span>Comprador</span>
            <BuyerSearch
              buyerSelected={uiState.buyer}
              onBuyerSelected={actions.updateBuyer}
              errorMessage={uiState.buyerError}
            />
          </Stack>
        </Block>
        <TableLayout
          header={
            <Box>
              <Box
                sx={{
                  margin: 0,
                  fontSize: '12px',
                  lineHeight: 1.5,
                  marginBottom: '12px',
                }}
              >
                Selecciona el producto
              </Box>
              <ProductSearch
                onProductSelected={actions.addProduct}
                alreadyAddedProductIds={uiState.products.map(
                  (product) => product.id
                )}
              />
            </Box>
          }
          body={
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={cellStyle}>Vendedor</TableCell>
                    <TableCell sx={cellStyle}>Producto</TableCell>
                    <TableCell sx={cellStyle}>Cantidad</TableCell>
                    <TableCell sx={cellStyle}>Nuevo precio</TableCell>
                    <TableCell sx={cellStyle}>Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {uiState.products.map((product) => (
                    <ProductLine
                      key={product.id}
                      product={product}
                      onChangeProductPrice={actions.updateCustomPrice}
                      onChangeProductQuantity={actions.updateQuantity}
                      onDeleteProduct={actions.deleteLine}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          }
        />

        <Block
          sx={{
            my: ' 16px',
            padding: '28px',
            position: 'relative',
          }}
        >
          {Boolean(uiState.products.length) && (
            <>
              {' '}
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 600,
                  fontSize: '12px',
                  color: COLORS.olive,
                  marginBottom: '12px',
                }}
              >
                Envíos
              </Typography>
              <Stack gap="16px">
                {uiState.sellers.map((sellerTicket) => (
                  <Box
                    key={sellerTicket.id}
                    sx={{
                      backgroundColor: COLORS.white,
                      border: `1px solid ${COLORS.gray_200}`,
                      borderRadius: '12px',
                      padding: '16px',
                    }}
                  >
                    <SellerTicket
                      key={sellerTicket.id}
                      sellerTicketUi={sellerTicket}
                      onChangeDeliveryDate={actions.updateDeliveryDate}
                      onStartTimeChange={actions.onStartTimeChange}
                      onEndTimeChange={actions.onEndTimeChange}
                      onChangeDeliveryNotes={actions.updateDeliveryNotes}
                    />
                  </Box>
                ))}
                <TotalTicket totalTicket={uiState.total} />
              </Stack>
            </>
          )}
        </Block>

        <Stack direction={'row'} gap={'16px'}>
          <Button
            sx={{ flex: '1' }}
            label={'Guardar carrito'}
            btnVariant={BUTTON_VARIANT.OUTLINED}
            onClick={actions.onClickedSaveDraft}
            disabled={uiState.saveCartButton?.disabled}
            loading={uiState.saveCartButton?.loading}
          />
          <Button
            sx={{ flex: '1' }}
            label={'Finalizar carrito'}
            btnVariant={BUTTON_VARIANT.PRIMARY}
            onClick={actions.onClickedSaveCart}
            disabled={uiState.finishCartButton?.disabled}
            loading={uiState.finishCartButton?.loading}
          />
        </Stack>
      </Stack>
    );
  }
);

const cellStyle = {
  fontWeight: 600,
  color: COLORS.olive,
  borderBottom: 'none',
  fontSize: '14px',
  textAlign: 'center',
};
